<!-- 获取时间段进场记录接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "parkCode":"2KKN885S",
              "enterTimeFrom": "20200301000000",
              "enterTimeTo": "20200331235959",
              "leaveStartTime": "20200325000000",
              "leaveEndTime": "20200325235959",
              "pageNum": "1",
              "pageSize": "2"
            },
            responseCode: 	{
                "data": {
                    "currCount": 1,
                    "recordInList": [
                        {
                            "carLicenseNumber": "未识别0927092703163",
                            "confidence": 0,
                            "correctConfidence": 0,
                            "enterCarCardNumber": "",
                            "enterCarColor": 0,
                            "enterCarLicenseColor": 0,
                            "enterCarLicenseNumber": "",
                            "enterCarLicenseType": 0,
                            "enterCarLogo": 0,
                            "enterChannelName": "",
                            "enterImageArray": [
                                {
                                    "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092709265304913364-body-in-nor.jpg?s=1aadff86",
                                    "plateImage": "http://221.4.168.157:13388/openydt/files/images/2017092709265304913364-plate-in-nor.jpg?s=e5ced83e"
                                }
                            ],
                            "enterRecognitionConfidence": 0,
                            "enterSpeed": 0,
                            "enterTime": "20170927092653",
                            "enterType": 0,
                            "enterVipType": 1,
                            "inOperatorName": "",
                            "isCorrect": 0,
                            "parkCode": "2KNTYVWC",
                            "parkName": "开发停车场2",
                            "parkingCode": "2017092709265304913364",
                            "recordType": 0
                        }
                    ],
                    "total": 600
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取指定时间段出场记录信息",
                t_url: this.commonUrls.test+"getCarOutList",
                p_url: this.commonUrls.prod+"getCarOutList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'areaIdList', info2: '否', info3: 'Long[]', info4: '区域id，仅支持云停车场' },
                        { info1: 'enterChannelNameList', info2: '否', info3: 'String[]', info4: '进场通道名称，仅支持云停车场' },
                        { info1: 'leaveChannelNameList', info2: '否', info3: 'String[]', info4: '出场通道名称，仅支持云停车场' },
                        { info1: 'enterTimeFrom', info2: '否', info3: 'String', info4: '进场时间段起始时间，yyyyMMddHHmmss，进场时间段不能大于一个月(enterTimeFrom和enterTimeTo、leaveStartTime和leaveEndTime 必选一组)' },
                        { info1: 'enterTimeTo', info2: '否', info3: 'String', info4: '进场时间段结束时间，yyyyMMddHHmmss，进场时间段不能大于一个月(enterTimeFrom和enterTimeTo、leaveStartTime和leaveEndTime 必选一组)' },
                        { info1: 'leaveStartTime', info2: '否', info3: 'String', info4: '出场时间段起始时间，yyyyMMddHHmmss，出场时间段不能大于一天(enterTimeFrom和enterTimeTo、leaveStartTime和leaveEndTime 必选一组)' },
                        { info1: 'leaveEndTime', info2: '否', info3: 'String', info4: '出场时间段结束时间，yyyyMMddHHmmss，出场时间段不能大于一天(enterTimeFrom和enterTimeTo、leaveStartTime和leaveEndTime 必选一组)' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多100条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'count', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'areaId', info2: '否', info3: 'Long', info4: '所属区域id' },
                        { info1: 'areaName', info2: '否', info3: 'String', info4: '所属区域名称' },
                        { info1: 'parkSysType', info2: '否', info3: 'Integer', info4: '车场类型（0 VEMS车场，1云车场，2第三方车场，3路边停车场）' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'enterChannelName', info2: '否', info3: 'String', info4: '进场通道名' },
                        { info1: 'enterVipType', info2: '是', info3: 'Integer', info4: '进场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客' },
                        { info1: 'enterCustomVipName', info2: '否', info3: 'String', info4: '进场VIP名称' },
                        { info1: 'inOperator', info2: '是', info3: 'String', info4: '进场放行操作员' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场放行类型，0未确认，1自动放行，2确认放行，3异常放行' },
                        { info1: 'enterImageArray', info2: '否', info3: 'JSONArray', info4: '进场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '出场时间，yyyyMMddHHmmss' },
                        { info1: 'leaveChannelName', info2: '否', info3: 'String', info4: '出场通道名' },
                        { info1: 'leaveVipType', info2: '是', info3: 'Integer', info4: '出场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客' },
                        { info1: 'leaveCustomVipName', info2: '否', info3: 'String', info4: '出场VIP名称' },
                        { info1: 'outOperator', info2: '是', info3: 'String', info4: '出场放行操作员' },
                        { info1: 'leaveType', info2: '是', info3: 'Integer', info4: '出场放行类型，0未确认，1自动放行，2确认放行，3异常放行' },
                        { info1: 'leaveImageArray', info2: '否', info3: 'JSONArray', info4: '出场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'leaveNovipCode', info2: '是', info3: 'Integer', info4: '出场说明（<url>参考附录:/Api/appendixData#appendixData_3</url>）' },
                        { info1: 'enterNovipCode', info2: '是', info3: 'Integer', info4: '进场说明（<url>参考附录:/Api/appendixData#appendixData_2</url>）' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getCarOutList.vue